import { useState, useEffect, useRef } from "react";

interface TopicModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (topic: string) => void;
  isLoading: boolean;
  buttonLabel?: string;
}

const CHIPS = [
  "ROI de RAG em fintech",
  "Lançamento do Claude 4.7",
  "Custos cloud FinOps 2026",
  "Lideranças tech em fintechs BR",
  "Open source vs SaaS",
  "AI agents em produção",
  "Privacy by design",
  "Carreira CTO solo",
];

export const TopicModal = ({ isOpen, onClose, onSubmit, isLoading, buttonLabel }: TopicModalProps) => {
  const [topic, setTopic] = useState("");
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (isOpen) {
      setTopic("");
      setTimeout(() => textareaRef.current?.focus(), 0);
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const valid = topic.trim().length >= 5;
  const handleSubmit = () => {
    if (!valid || isLoading) return;
    onSubmit(topic.trim());
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="topic-modal-title"
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg p-6 w-[32rem] max-w-[90vw] space-y-4"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="topic-modal-title" className="text-lg font-semibold">Novo draft com tema</h3>

        <div className="flex flex-wrap gap-2">
          {CHIPS.map((chip) => (
            <button
              key={chip}
              type="button"
              onClick={() => {
                setTopic(chip);
                textareaRef.current?.focus();
              }}
              disabled={isLoading}
              className="rounded-full border border-slate-300 px-3 py-1 text-xs text-slate-700 hover:bg-slate-100 disabled:opacity-50"
            >
              {chip}
            </button>
          ))}
        </div>

        <textarea
          ref={textareaRef}
          value={topic}
          onChange={(e) => setTopic(e.target.value)}
          rows={4}
          placeholder="ROI de RAG em fintech, lançamento do Claude 4.7, Lula no G20..."
          disabled={isLoading}
          className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 resize-none disabled:bg-slate-50"
        />

        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="rounded-lg border border-slate-300 px-4 py-2 text-sm"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={!valid || isLoading}
            className="rounded-lg bg-slate-900 text-white px-4 py-2 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {buttonLabel || "Gerar"}
          </button>
        </div>
      </div>
    </div>
  );
};
